import React, { useState, useEffect } from "react";
import "./../assets/css/navbar.css";
import { motion, AnimatePresence } from "framer-motion";
import { NavLink } from "react-router-dom";
import Logo from '../assets/images/logo.png';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "HOME", path: "/" },
    { name: "ABOUT", path: "/about" },
    { name: "SERVICES", path: "/services" },
    { name: "GALLERY", path: "/gallery" },
    { name: "CONTACT", path: "/contact" },
  ];

  return (
    <nav className={`navbar ${scroll ? "scrolled" : ""}`}>
      <div className="container ">

        {/* LOGO */}
        <motion.div
          className="logo"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <img src={Logo} className=" m-0 p-0" height={50} alt="logo" />
          TRIP <span>WORD</span>
        </motion.div>

        {/* NAV LINKS */}
        <ul className="nav-links">
          {navItems.map((item, i) => (
            <li key={i} className="nav-item">
              <NavLink to={item.path} className="nav-link">
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* MOBILE ICON */}
        <div className="menu-icon" onClick={() => setOpen(true)}>
          ☰
        </div>

        {/* MOBILE MENU */}
        <AnimatePresence>
          {open && (
            <motion.div
              className="mobile-menu"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
            >
              <div className="close-btn" onClick={() => setOpen(false)}>
                ✖
              </div>

              {navItems.map((item, i) => (
                <NavLink
                  key={i}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className="mobile-link"
                >
                  {item.name}
                </NavLink>
              ))}
            </motion.div>
          )}
        </AnimatePresence>

      </div>
    </nav>
  );
}